import { useTranslation } from "react-i18next"
import { Button, Form, Row } from 'react-bootstrap'
import { useEffect, useState } from "react"

export default function FormOrigen({submit, isNew, inputChange, handleCheckbox, state, origens}) {
    const { t } = useTranslation()

    const [origens_array, setOrigenOptions] = useState([])

    const saveOrigen = ({target})=>{
        let origensCopy = origens_array
        origensCopy[target.getAttribute('origen')].distance = target.value
        inputChange({target:{name: 'distances', value: origensCopy}})
    }

    useEffect(() => {
        let origensOption = []

        origens?.forEach((ele, ind) =>{
            if(ele.type === false){
                const stateOrigen = state.distances?.find(distance => distance.origen === ele._id)
                if (ele._id !== state.idOrigen) {
                    let object = {origen: ele._id, name: ele.name, distance: stateOrigen?.distance ? stateOrigen.distance : ''}
                    origensOption.push(object)
                }
            }
        })
        setOrigenOptions(origensOption)
    }, [state, origens])

    return (
        <>
            <Form onSubmit={submit}>
                <Form.Group>
                    <Form.Label className="form-label mt-3">{t('origens.name')}</Form.Label>
                    <Form.Control className="form-control"
                        type='text'
                        name='name' 
                        value={state.name || state.nameEdit ||  ''}
                        placeholder={t('origens.name')}
                        onChange={inputChange}
                        required
                    />
                </Form.Group>
                <Form.Group>
                    <Form.Label className="form-label mt-3">{t('origens.type')}</Form.Label>
                    <Form.Check className='float-left mt-3 pe-3' type='checkbox' name='type' onChange={handleCheckbox} checked={state.type || false} />
                </Form.Group>
                {
                    state?.type
                        ?
                            origens_array?.map((origen, key) =>{
                                return (
                                    <Form.Group key={key}>
                                        <Form.Label className="form-label mt-3">{origen.name}</Form.Label>
                                        <Form.Control className="form-control"
                                            type='number'
                                            name='distance' 
                                            value={origen.distance}
                                            origen={key}
                                            placeholder={t('origens.distance')}
                                            onChange={saveOrigen}
                                        />
                                    </Form.Group>
                                )
                            })
                        :
                        <>
                        </>
                }
                <Row className="text-left custom-card-header-list">
                    {
                        isNew === false
                        ?
                        <Button className="btn btn-secondary my-2 mx-auto" type="submit"><i className="fas fa-save"></i> {t('origens.update')}</Button>
                        :
                        <Button className="btn btn-secondary my-2 mx-auto" type="submit"><i className="fas fa-save"></i> {t('origens.new')}</Button>
                    }
                </Row>
            </Form>
        </>
    )    
}
